const React = require('react');
const ReactDOM = require('react-dom/client');
const moment = require('moment');
require('moment/locale/es');

moment.locale('es');

exports.replaceHydrateFunction = () => {
  return (element, container) => {
    const root = ReactDOM.createRoot(container);
    root.render(element);
  }
};